// Convert URL Parameters into types the web API uses
const RouteUtils = {
    MarketFilters: {
        'spreads': 'spread',
        'moneylines': '2way',
        'totals': 'total',
        'puck-lines': 'puck_line',
        'run-lines': 'run_line',
    },
    Leagues: {
        'nfl': 'nfl',
        'nba': 'nba',
        'college-football': 'ncaaf',
        'college-basketball': 'ncaab',
        'nhl': 'nhl',
        'mlb': 'mlb',
    },
    getDefaultMarketFilter: (league) => {
        if (league === 'nhl') {
            return 'moneylines';
        } else {
            return 'spreads'
        }
    },
    getLeague: (urlLeague) => RouteUtils.Leagues[urlLeague],
    getMarketFilter: (league, urlMarketFilter) => {
        if (!urlMarketFilter) {
            return league === 'nhl' ? RouteUtils.MarketFilters['puck-lines'] : league === 'mlb' ? RouteUtils.MarketFilters['run-lines'] : RouteUtils.MarketFilters['spreads'];
        }

        if (league === 'nhl') {
            return urlMarketFilter === 'spreads' ? RouteUtils.MarketFilters['puck-lines'] : RouteUtils.MarketFilters[urlMarketFilter];
        } else if (league === 'mlb') {
            return urlMarketFilter === 'spreads' ? RouteUtils.MarketFilters['run-lines'] : RouteUtils.MarketFilters[urlMarketFilter];
        } else {
            return RouteUtils.MarketFilters[urlMarketFilter]
        }
    },
    getUrlMarketFilter: (marketFilter) => Object.keys(RouteUtils.MarketFilters).find(key => RouteUtils.MarketFilters[key] === marketFilter),
    getGameEventUrl: (game) => ""
}

export default RouteUtils;